import { u as e } from "./jsxRuntime.module-Bzuv3cXw.js";
import { useCallback as s } from "preact/hooks";
function m({ onClick: i, as: r, children: f, componentProps: a }) {
  const l = {
    ...a,
    onClick: s(
      (u) => {
        i(), a?.onClick?.(u);
      },
      [i, a]
    )
  }, t = r ?? (a && "href" in a ? "a" : "span");
  return /* @__PURE__ */ e(t, { ...l, children: f });
}
export {
  m as B
};
